// @flow
import React from 'react';
import { WhitePanelLayout } from './imports';

export default function ListProperty({isMobile= false}) {
  return (
   <WhitePanelLayout className={`list-prop ${ isMobile ? 'd-none d-xl-block': ''}`}>
     <h4>Earn money by listing your property</h4>
     <a href="https://forms.gle/EimF2z5PEGdSSUnXA" target="_blank" rel="noopener noreferrer" className="btn btn-yellow" style={{ width: '100%' }}>Apply Now</a>
   </WhitePanelLayout>
  );
}
